import React from "react";
import { Fonts } from "../font";

export interface ITheme {
  title: string;
  key: string;
  fonts: {
    primary: IFontWeights;
    secondary: IFontWeights;
    baseSize: number;
  };
  colors: {
    primary: IColorVariants;
    secondary: IColorVariants;
    neutralLighter: IColorVariants;
    neutralDarker: IColorVariants;
    success: IColorVariants;
    warning: IColorVariants;
    danger: IColorVariants;
    info: IColorVariants;
  };
  grid: {
    breakPoints: {
      s: number;
      m: number;
      l: number;
      xl: number;
      xxl: number;
    };
  };
}

interface IFontWeights {
  light: string;
  regular: string;
  bold: string;
}

interface IColorVariants {
  main: string;
  dark: string;
  light: string;
  contrast: string;
}

export const defaultTheme: ITheme = {
  title: "System",
  key: "system",
  fonts: {
    primary: {
      light: Fonts.RobotoLight,
      regular: Fonts.RobotoRegular,
      bold: Fonts.RobotoBold,
    },
    secondary: {
      light: Fonts.RobotoLight,
      regular: Fonts.RobotoRegular,
      bold: Fonts.RobotoBold,
    },
    baseSize: 16,
  },
  colors: {
    primary: {
      main: "#DA291C",
      light: "#EB4930",
      dark: "#B72110",
      contrast: "#F2F2F2",
    },
    secondary: {
      main: "#6295AC",
      light: "#81A9BC",
      dark: "#437285",
      contrast: "#F2F2F2",
    },
    neutralLighter: {
      main: "#F2F2F2",
      light: "#FFFFFF",
      dark: "#BCBCBC",
      contrast: "#333333",
    },
    neutralDarker: {
      main: "#333333",
      light: "#999999",
      dark: "#000000",
      contrast: "#F2F2F2",
    },
    success: {
      main: "#19C449",
      light: "#1AD44E",
      dark: "#008E2A",
      contrast: "#F2F2F2",
    },
    warning: {
      main: "#D2A811",
      light: "#E2B515",
      dark: "#B79210",
      contrast: "#F2F2F2",
    },
    danger: {
      main: "#DA291C",
      light: "#EB4930",
      dark: "#B72110",
      contrast: "#F2F2F2",
    },
    info: {
      main: "#6295AC",
      light: "#81A9BC",
      dark: "#437285",
      contrast: "#F2F2F2",
    },
  },
  grid: {
    breakPoints: {
      s: 320,
      m: 640,
      l: 960,
      xl: 1200,
      xxl: 1500,
    },
  },
};

export interface ThemeProviderConfig {
  initial?: string;
  options?: ITheme[];
}

export interface ThemeProviderProps extends React.PropsWithChildren, ThemeProviderConfig {}
